var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editing)?_c('div',{staticClass:"save-button-holder"},[_c('button',{on:{"click":function($event){return _vm.$emit('save')}}},[_vm._v(" "+_vm._s(_vm.save ? _vm.save : _vm.$t('save'))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }